module.exports = ".statusdue {\n  margin-top: 30px;\n  background-color: #fffcfc;\n  padding: 10px;\n  margin-left: 0px !important;\n  margin-right: 0px !important; }\n\n.searchBytext {\n  background-color: #fffcfc;\n  padding: 8px;\n  border-radius: 4px;\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n  margin-top: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/service-due-report/service-due-report.component.scss
// module id = ./client/app/service-due-report/service-due-report.component.scss
// module chunks = main